module.exports = __webpack_public_path__ + "img/worldcup-bg-mobile.324a2b19.webp";